import type { Routes } from '@angular/router';

export const appQuippyRoutes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: 'new' },
    {
        path: 'new',
        loadComponent: () =>
            import('./chat-page').then((page) => page.AppQuippyChatPage),
    },
    {
        path: ':chatId',
        loadComponent: () =>
            import('./chat-page').then((page) => page.AppQuippyChatPage),
    },
];
